import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { JstDate } from '../../core/time/business-time';
import { clockView } from '../../core/time/business-time';
import { BusinessClock } from '../../core/time/business-clock.service';
import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { MemberService } from '../../core/services/member.service';
import { StudioService } from '../../core/services/studio.service';

const CHARGE_TYPE_OPTIONS = [
  { id: 1, name: '月会費' }, { id: 2, name: '入会金・事務手数料' },
  { id: 3, name: 'ロッカー費' }, { id: 4, name: 'PT費' },
  { id: 5, name: '物販' }, { id: 0, name: 'その他' },
];

@Component({
    selector: 'app-transaction-new',
    imports: [MaxLengthValidatorDirective, FormsModule, DecimalPipe],
    template: `
<div class="modal-backdrop fade show" (click)="close()"></div>
<div class="modal fade show d-block" id="createTransactionModal" tabindex="-1" role="dialog" aria-labelledby="createTransactionModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="createTransactionModalLabel">新規作成@if (!inTheInput) { <span> 確認</span> }</h5>
        <button type="button" class="close" (click)="close()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <form novalidate name="myNewForm" #myNewForm="ngForm" (ngSubmit)="save(myNewForm)">
        <div class="modal-body">
          @if (loading) {
            <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
          } @else {
            <div class="row">
              <div class="col-md-12">
                <!-- 旧版 transaction-member.html:341-345 の modal-body 先頭 <flash-message> 相当 -->
                @if (successMessage) {
                  <div class="alert alert-success alert-dismissible" role="alert">
                    {{ successMessage }}
                    <button type="button" class="close" aria-label="通知を閉じる" (click)="clearSuccessMessage()"><span aria-hidden="true">&times;</span></button>
                  </div>
                } @else { <div style="height: 1px"></div> }
              </div>
              <div class="col-md-12">
                @if (inTheInput) {
                  <div class="form-group row"><label class="col-md-4 col-form-label">店舗</label><label class="col-md-8 col-form-label">{{ member?.studio?.name }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">売上年月</label><label class="col-md-8 col-form-label">{{ form.yearPay }}年{{ form.monthPay }}月</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">会員ID</label><label class="col-md-8 col-form-label">{{ member?.memberCode }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">会員氏名</label><label class="col-md-8 col-form-label" style="word-wrap: break-word;">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</label></div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">支払方法</label>
                    <label class="col-md-8 col-form-label">
                      @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
                      @if (member?.payment?.paymentMethod == 1) { <span>クレジット</span> }
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">売上タイプ</label>
                    <div class="col-md-8">
                      <select class="form-control" [(ngModel)]="form.chargeType" name="chargeType" (ngModelChange)="onChargeTypeChange()" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (option of chargeTypeOptions; track option.id) { <option [ngValue]="option.id">{{ option.name }}</option> }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">商品</label>
                    <div class="col-md-8">
                      <select class="form-control" [(ngModel)]="form.product" name="product" (ngModelChange)="updateAmount()" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (product of filteredProducts; track product.id) {
                          <option [ngValue]="product">(¥{{ productTaxIncluded(product) | number:'1.0-0' }}) {{ product.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">調整額</label>
                    <div class="col-md-8">
                      <input type="number" class="form-control" [(ngModel)]="form.adjustment" name="adjustment" (ngModelChange)="updateAmount()"
                        [min]="form.product ? -productTaxIncluded(form.product) : 0" max="99999" step="1" placeholder="調整範囲: ±99999">
                    </div>
                  </div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">金額</label><div class="col-md-8 col-form-label">¥{{ transactionTotal | number:'1.0-0' }}</div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">明細</label><div class="col-md-8"><input type="text" class="form-control" [(ngModel)]="form.title" name="title" maxlength="200" required></div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">備考</label><div class="col-md-8"><input type="text" class="form-control" [(ngModel)]="form.note" name="note" sfMaxLength="200"></div></div>
                } @else {
                  <div class="form-group row"><label class="col-md-12 col-form-label">下記の内容で売上を登録します。よろしいですか。</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">店舗</label><label class="col-md-8 col-form-label">{{ member?.studio?.name }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">売上年月</label><label class="col-md-8 col-form-label">{{ form.yearPay }}年{{ form.monthPay }}月</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">会員ID</label><label class="col-md-8 col-form-label">{{ member?.memberCode }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">会員氏名</label><label class="col-md-8 col-form-label" style="word-wrap: break-word;">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">支払方法</label><label class="col-md-8 col-form-label">{{ member?.payment?.paymentMethod == 0 ? '口座振替' : 'クレジット' }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">売上タイプ</label><label class="col-md-8 col-form-label">{{ chargeTypeName(form.chargeType) }}</label></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">商品</label><div class="col-md-8">(¥{{ productTaxIncluded(form.product) | number:'1.0-0' }}) {{ form.product?.name }}</div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">調整額</label><div class="col-md-8">¥{{ (form.adjustment || 0) | number:'1.0-0' }}</div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">金額</label><div class="col-md-8 col-form-label">¥{{ transactionTotal | number:'1.0-0' }}</div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">明細</label><div class="col-md-8">{{ form.title }}</div></div>
                  <div class="form-group row"><label class="col-md-4 col-form-label">備考</label><div class="col-md-8">{{ form.note }}</div></div>
                }
              </div>
            </div>
          }
        </div>
        <div class="modal-footer">
          @if (inTheInput) {
            <button class="btn bg-close text-white" type="button" (click)="close()"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            <button class="btn btn-success" type="button" (click)="showConfirmation(myNewForm)" [disabled]="loading || isInvalid()"><i class="fa s-icon-save"></i>&nbsp;確認</button>
          } @else {
            <button class="btn bg-close text-white" type="button" (click)="inTheInput = true"><i class="fa s-icon-cancel"></i>&nbsp;戻る</button>
            <button type="submit" class="btn btn-success" [disabled]="saving || isInvalid()"><i class="fa s-icon-save fa-fw"></i>&nbsp;保存</button>
          }
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class TransactionNewComponent implements OnInit, OnDestroy {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView();
  private memberService = inject(MemberService);
  private studioService = inject(StudioService);
  private zone = inject(NgZone);

  @Input({ required: true }) memberId!: number;
  @Input({ required: true }) member: any;
  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();

  products: any[] = [];
  loading = true;
  saving = false;
  inTheInput = true;
  successMessage: string | null = null;
  private successMessageTimer?: ReturnType<typeof setTimeout>;
  readonly chargeTypeOptions = CHARGE_TYPE_OPTIONS;
  form = this.createInitialForm();

  get filteredProducts(): any[] {
    if (this.form.chargeType == null) return [];
    return this.products.filter(product => Number(product.productType) === Number(this.form.chargeType));
  }

  get transactionTotal(): number {
    return this.form.product
      ? this.productTaxIncluded(this.form.product) + Number(this.form.adjustment || 0)
      : 0;
  }

  async ngOnInit(): Promise<void> {
    try {
      if (this.member?.studio?.id) {
        const products: any[] = await this.studioService.getProduct(this.member.studio.id) ?? [];
        this.products = products.filter(product => product.status === 0);
      }
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy(): void { this.clearSuccessMessage(); }

  close(): void { this.closed.emit(); }

  clearSuccessMessage(): void {
    if (this.successMessageTimer !== undefined) clearTimeout(this.successMessageTimer);
    this.successMessageTimer = undefined;
    this.successMessage = null;
  }

  private showSuccessMessage(text: string): void {
    this.clearSuccessMessage();
    this.successMessage = text;
    this.successMessageTimer = this.zone.runOutsideAngular(() =>
      setTimeout(() => this.zone.run(() => this.clearSuccessMessage()), 5000));
  }

  showConfirmation(form: NgForm): void {
    if (form.invalid || this.isInvalid()) {
      form.control.markAllAsTouched();
      return;
    }
    this.inTheInput = false;
  }

  onChargeTypeChange(): void {
    this.form.product = null;
    this.form.adjustment = null;
    this.form.title = this.form.chargeType == null
      ? ''
      : `${this.form.yearPay}年${this.form.monthPay}月分 ${this.chargeTypeName(this.form.chargeType)}`;
  }

  updateAmount(): void {
    if (!this.form.product) this.form.adjustment = null;
  }

  productTaxIncluded(product: any): number {
    if (!product) return 0;
    return Math.floor(Number(product.amount || 0) * (1 + Number(product.taxRate?.rate || 0)));
  }

  chargeTypeName(id: number | null): string {
    return this.chargeTypeOptions.find(option => option.id === Number(id))?.name ?? '';
  }

  isInvalid(): boolean {
    if (this.loading || this.form.chargeType == null || !this.form.product || !String(this.form.title || '').trim()) return true;
    const adjustment = this.form.adjustment === null || this.form.adjustment === '' ? 0 : Number(this.form.adjustment);
    return !Number.isInteger(adjustment) || adjustment < -this.productTaxIncluded(this.form.product) || adjustment > 99999;
  }

  async save(form: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (form.invalid || this.isInvalid()) return;
    this.saving = true;
    try {
      const product = this.form.product;
      const taxIncluded = this.transactionTotal;
      const rate = Number(product.taxRate?.rate || 0);
      const taxExcluded = Math.ceil(taxIncluded / (1 + rate));
      await this.memberService.upsertTransaction(this.memberId, {
        yearPay: this.form.yearPay,
        monthPay: this.form.monthPay,
        chargeType: this.form.chargeType,
        title: this.form.title,
        note: this.form.note || null,
        productId: product.id,
        taxAmount: taxIncluded - taxExcluded,
        amount: taxIncluded,
        memberId: this.member.id,
        studioId: this.member.studio.id,
        paymentMethod: this.member.payment?.paymentMethod,
        isAutoGenerate: 1,
      });
      // 旧版 transaction.js:690-698: modal内Flash「データを作成しました」、売上タイプ・明細・備考をclearして親一覧を再取得
      // （売上タイプ未選択では商品候補が空になるため商品も未選択へ戻す。年月・調整額は保持）
      this.showSuccessMessage('データを作成しました');
      this.saved.emit();
      this.form = { ...this.form, chargeType: null, product: null, title: '', note: null };
      this.inTheInput = true;
      form.resetForm(this.form);
    } finally {
      this.saving = false;
    }
  }

  private createInitialForm(): any {
    const now = new JstDate();
    const target = now.getDate() < 11 ? now : new JstDate(now.getFullYear(), now.getMonth() + 1, 1);
    return {
      yearPay: target.getFullYear(),
      monthPay: target.getMonth() + 1,
      chargeType: null,
      product: null,
      adjustment: null,
      title: '',
      note: '',
    };
  }
}
